// extracted by mini-css-extract-plugin
module.exports = {"tos_title":"TosPopup_tos_title__2eM6b","tosContentContainer":"TosPopup_tosContentContainer__1Pt6c","iframe":"TosPopup_iframe__1DBmi"};